<template>
  <article class="stack-item supplier-info media">
    <figure class="supplier-image-wrapper media-left">
      <div class="image is-48x48">
        <img
          v-if="imageUrl"
          class="is-rounded lazyload"
          :src="imageUrl"
          v-img-fallback="'/img/supplier_avatar.png'"
          alt="avatar"
        />
        <img
          v-else
          class="is-rounded lazyload"
          src="/img/supplier_avatar.png"
          alt="avatar"
        />
      </div>
      <div class="rating" v-if="rate">
        <span>{{ rate }}</span>
        <span>&#9733;</span>
      </div>
    </figure>
    <div class="media-content">
      <div class="content">
        <div v-if="isRide">
          <div>
            <strong> {{ name }} </strong>
          </div>
        </div>
        <div v-else>
          <div v-if="isAcceptedStatus">
            <div
              v-if="timeForPickup === null || timeForPickup === 0"
              v-html="
                $t(
                  'SHARE_ORDER.SUPPLIER_STATUS.DRIVER_IS_PICKING_UP_A_FEW_MINS',
                  { name: name }
                )
              "
            ></div>
            <div
              v-if="timeForPickup !== 0"
              v-html="
                $t('SHARE_ORDER.SUPPLIER_STATUS.DRIVER_IS_PICKING_UP', {
                  name: name,
                  time: timeForPickup,
                })
              "
            ></div>
          </div>

          <div v-if="isInProcessStatus">
            <div
              v-if="timeForDropoff === null || timeForDropoff === 0"
              v-html="
                $t(
                  'SHARE_ORDER.SUPPLIER_STATUS.DRIVER_IS_DROPING_OFF_A_FEW_MINS',
                  { name: name }
                )
              "
            ></div>
            <div
              v-if="timeForDropoff !== 0"
              v-html="
                $t('SHARE_ORDER.SUPPLIER_STATUS.DRIVER_IS_DROPING_OFF', {
                  name: name,
                  time: timeForDropoff,
                })
              "
            ></div>
          </div>

          <div
            v-if="isBoardedStatus === true"
            v-html="
              $t('SHARE_ORDER.SUPPLIER_STATUS.DRIVER_IS_BOARD', {
                name: name,
              })
            "
          ></div>

          <div
            v-if="!isAcceptedStatus && !isInProcessStatus && !isBoardedStatus"
          >
            <strong>{{ name }} </strong>
          </div>
        </div>

        <span v-if="plateNumber">{{ plateNumber }}</span>
      </div>
    </div>
    <div class="media-right">
      <!-- <button class="delete"></button> -->
      <a class="phone-icon" :href="refPhoneNumber" v-show="phoneNumber">
        <span class="icon">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path
              fill="#fff"
              d="M15,12H17A5,5 0 0,0 12,7V9A3,3 0 0,1 15,12M19,12H21C21,7 16.97,3 12,3V5C15.86,5 19,8.13 19,12M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5Z"
            />
          </svg>
        </span>
        <span class="phone-number">{{ phoneNumber }}</span>
      </a>
    </div>
  </article>
</template>

<script>
import { ImgFallback } from "v-img-fallback";
import { mapGetters } from "vuex";

const DURATION_TIME = 60000;
export default {
  name: "SupplierInfo",
  props: {
    imageUrl: String,
    plateNumber: String,
    phoneNumber: String,
    initRate: Number,
    name: String,
    disablePhone: Boolean,
    isRide: Boolean,
  },
  directives: {
    ImgFallback,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      locateInterval: null,
      currentOrderStatus: null,
    };
  },
  computed: {
    ...mapGetters(["etaForPickup", "etaForDropoff"]),
    timeForPickup() {
      return Math.ceil(this.etaForPickup);
    },
    timeForDropoff() {
      let result = null;
      for (let i = 1; i < this.etaForDropoff.length; i++) {
        if (this.etaForDropoff[i] !== 0) {
          result = this.etaForDropoff[i];
          break;
        }
      }
      return Math.ceil(result);
    },
    orderDetail: {
      cache: false,
      get() {
        return this.$store.state.order_detail;
      },
    },
    refPhoneNumber: {
      cache: false,
      get() {
        return `tel:${this.phoneNumber}`;
      },
    },
    isDisablePhoneForPartner() {
      const getters = this.$store.getters;
      return getters.isHeinekenOrder || getters.isDrinkiesOrder;
    },
    isAcceptedStatus() {
      return (
        this.$store.state.order_detail.status ===
        this.$constants.ORDER_STATUS.ACCEPTED
      );
    },
    isInProcessStatus() {
      return (
        this.$store.state.order_detail.status ===
        this.$constants.ORDER_STATUS.IN_PROCESS
      );
    },
    isBoardedStatus() {
      return (
        this.$store.state.order_detail.status ===
        this.$constants.ORDER_STATUS.BOARDED
      );
    },
    rate() {
      if (this.initRate && !isNaN(this.initRate)) {
        return parseFloat(parseFloat(this.initRate).toFixed(2));
      } else return null;
    },
  },
  methods: {
    stopInterval() {
      if (this.locateInterval) {
        clearInterval(this.locateInterval);
      }
    },

    supplierETA() {
      this.$store.dispatch("getSupplierETA", this.orderDetail._id);
    },
    setInterval() {
      const duration = DURATION_TIME;
      this.stopInterval();
      this.locateInterval = setInterval(
        function() {
          this.supplierETA();
        }.bind(this),
        duration
      );
    },
  },
  mounted() {
    if (this.isAcceptedStatus || this.isInProcessStatus) {
      this.setInterval();
    }
  },
  watch: {},
};
</script>

<style lang="scss">
.supplier-info {
  padding-bottom: 15px;
  padding-top: 3px;

  .supplier-image-wrapper {
    position: relative;

    .image {
    }
    .rating {
      position: absolute;
      z-index: 10;
      font-size: 11px;
      width: 46px;
      border-radius: 3px;
      text-align: center;
      font-weight: 600;
      bottom: -11px;
      background: #fff;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
        0 2px 10px 0 rgba(0, 0, 0, 0.12);

      span:nth-child(2) {
        padding-left: 1px;
        color: #ff9800;
      }
    }
  }

  .media-content {
    padding-top: 3px;

    .content {
      span:last-child {
        font-size: 12px;
        border-radius: 2px;
        border: 1px solid #f3f3f3;
        background-color: #fff;
        display: inline-block;
        padding: 0;
        margin: 0;
        width: 100px;
        text-align: center;
        height: 18px;
        line-height: 18px;
      }
    }
  }

  .media-right {
    position: relative;
    height: 2rem;
    margin-top: 0.5rem;

    .phone-icon {
      .icon {
        width: 2rem;
        height: 2rem;
        background-color: #4caf50;
        color: white;
        border-radius: 50px;
      }
    }

    .phone-number {
      visibility: hidden;
      font-size: 13px;
      width: 110px;
      background-color: #fff;
      text-align: center;
      border-radius: 2px;
      position: absolute;
      z-index: 1;
      bottom: 80%;
      left: 50%;
      margin-left: -92px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
        0 2px 10px 0 rgba(0, 0, 0, 0.12);
    }

    .phone-number::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 84%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #fff transparent transparent transparent;
    }

    .phone-icon:hover .phone-number {
      visibility: visible;
    }
  }
}
</style>
